import ArgumentAssertionBuilder from './ArgumentAssertionBuilder';
import ArgumentException from '../Exceptions/ArgumentException';
import DefaultComparers from '../Comparers/DefaultComparers';
import { format } from '../Strings';
import SR from '../i18n/en/assertions.strings.json';
export default class CompareAssertionBuilder extends ArgumentAssertionBuilder {
    /// <summary>
    /// Ensures the argument is greater than or equal to the specified value.
    /// </summary>
    /// <param name="this">The this.</param>
    /// <param name="value">The value.</param>
    /// <exception cref="System.ArgumentNullException"></exception>
    isGreaterThanOrEqualTo(value) {
        if (DefaultComparers.DefaultComparer.compare(this.argument.valueOf(), value) < 0) {
            throw new ArgumentException(format(SR.isGreaterThanOrEqualToExceptionMessage, this.argumentName, value), this.argumentName);
        }
        return this;
    }
    /// <summary>
    /// Ensures the argument is less than or equal to the specified value.
    /// </summary>
    /// <param name="this">The this.</param>
    /// <param name="value">The value.</param>
    /// <exception cref="System.ArgumentNullException"></exception>
    isLessThanOrEqualTo(value) {
        if (DefaultComparers.DefaultComparer.compare(this.argument.valueOf(), value) > 0) {
            throw new ArgumentException(format(SR.isLessThanOrEqualToExceptionMessage, this.argumentName, value), this.argumentName);
        }
        return this;
    }
    /// <summary>
    /// Ensures the argument is less than the specified value.
    /// </summary>
    /// <param name="this">The this.</param>
    /// <param name="value">The value.</param>
    /// <exception cref="System.ArgumentNullException"></exception>
    isLessThan(value) {
        if (DefaultComparers.DefaultComparer.compare(this.argument.valueOf(), value) != -1) {
            throw new ArgumentException(format(SR.isLessThanExceptionMessage, this.argumentName, value), this.argumentName);
        }
        return this;
    }
    /// <summary>
    /// Ensures the argument is greater than the specified value.
    /// </summary>
    /// <param name="this">The this.</param>
    /// <param name="value">The value.</param>
    /// <exception cref="System.ArgumentNullException"></exception>
    isGreaterThan(value) {
        if (DefaultComparers.DefaultComparer.compare(this.argument.valueOf(), value) != 1) {
            throw new ArgumentException(format(SR.isGreaterThanExcepetionMessage, this.argumentName, value), this.argumentName);
        }
        return this;
    }
    /// <summary>
    /// Ensures the argument is equal to the specified value.
    /// </summary>
    /// <param name="this">The this.</param>
    /// <param name="value">The value.</param>
    /// <exception cref="System.ArgumentNullException"></exception>
    isEqualTo(value) {
        if (DefaultComparers.DefaultComparer.compare(this.argument.valueOf(), value) != 0) {
            throw new ArgumentException(format(SR.isEqualToExceptionMessage, this.argumentName, value), this.argumentName);
        }
        return this;
    }
}
